import { t } from "@i18n";
import { MdOutlineWrapText } from "react-icons/md";
import { BUTTON_TYPES } from "../../../cubeComponent/constants/globalVariable";
import ButtonComponent from "../../../cubeComponent/form/ButtonComponent";
import IconComponent from "../../../cubeComponent/icons";
import { manageWBSItemSteps, mileStoneStatus } from "./constant";
import { folderPermissions } from "../../../../../helpers/index";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";

export function getContractCRUDPermission(contractDetails: any = {}, changeOrderState: any = {}) {
  const { RESOURCE_MODIFY } = folderPermissions();
  if (!contractDetails.userPermissions?.includes(RESOURCE_MODIFY.id)) {
    return false;
  }
  return !contractDetails.lockData?.isLocked || changeOrderState?.isEnabled;
}

export function getTotal(records: any, fieldName: any) {
  if (!records) {
    return 0;
  }
  return records?.reduce((total: any, object: any) => {
    if (object.children) {
      return total + getTotal(object.children, fieldName);
    }
    return total + object[fieldName];
  }, 0);
}

export function changeTypeButtonTemplate() {
  return (
    <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="changeType">
      <span className="flex items-center gap-1">
        <IconComponent name="changeType" width="1rem" height="1rem" />
        {t("Change Type")}
      </span>
    </ButtonComponent>
  );
}

export function editButtonTemplate() {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="edit">
        <span className="flex items-center gap-1">
          <IconComponent name="editProfile" width="1.25rem" height="1.25rem" />
          {t("Edit")}
        </span>
      </ButtonComponent>
    </div>
  );
}
export function updateButtonTemplate() {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="update">
        <span className="flex items-center gap-1">
          <IconComponent name="Update" width="1rem" height="1rem" />
          {t("Update")}
        </span>
      </ButtonComponent>
    </div>
  );
}

export function cancelButtonTemplate() {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="cancel">
        <span className="flex items-center gap-1">
          <IconComponent name="Cancel" width="1rem" height="1rem" />
          {t("Cancel")}
        </span>
      </ButtonComponent>
    </div>
  );
}

export function deleteBtnTemplate() {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="delete">
        <span className="flex items-center gap-1">
          <IconComponent name="delete" width="1.25rem" height="1.25rem" />
          {t("Delete")}
        </span>
      </ButtonComponent>
    </div>
  );
}
export function assignWBSTemplate() {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="attachToWBSItem">
        <span className="flex items-center gap-1">
          <IconComponent name="smallAttachmentIcon" width="1rem" height="1rem" />
          {t("Assign To WBS")}
        </span>
      </ButtonComponent>
    </div>
  );
}
export function wrapTextButtonTemplate(state = false) {
  return (
    <div className="">
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="wrap_text">
        <span className="flex items-center gap-1">
          <MdOutlineWrapText />
          {state ? t("Un Wrap Text") : t("Wrap Text")}
        </span>
      </ButtonComponent>
    </div>
  );
}

export const getGridColumns = ({
  source,
  showManageItemModal,
  editTemplate,
  itemTypeTemplate,
  HSN_SAC_EditTemplate,
  descEditTemplate,
  rateEditTemplate,
  unitEditTemplate,
  unitTemplate,
  quantityEditTemplate,
  quantityTemplate,
  linkedQuantityTemplate,
  amountTemplate,
  assignedQuantityTemplate,
  detailTemplate,
  showInfoColumn = false,
  showDetailedColumns = false,
  wbsItemsTemplate,
  showQuantityInputBox,
  showRemarksColumn = false,
  remarksTemplate,
  isRustomjeePortal = false,
  changeOrderState,
  Formatters,
}: any) => {
  const columnsList = [
    ...(showInfoColumn
      ? [
          {
            field: "sourceFormNo",
            id: "sourceFormNo",
            name: t("Info"),
            formatter: detailTemplate,
            width: 100,
          },
        ]
      : []),
    {
      field: "serial",
      id: "serial",
      name: t("S. No"),
      width: 120,
      formatter: Formatters.tree,
      minWidth: 100,
    },
    {
      name: t("Item Type"),
      field: "type",
      id: "type",
      minWidth: 100,
      filterType: "Text",
      formatter: itemTypeTemplate,
    },
    {
      name: t("Code"),
      field: "code",
      id: "code",
      width: 120,
      minWidth: 100,
      filterType: "Text",
      allowEditing: false,
      formatter: (data: number, value: number, a: any, b: unknown, args: any) => args.code ?? "",
    },
    {
      name: t("HSN/SAC"),
      field: "HSN_SAC",
      id: "HSN_SAC",
      width: 120,
      minWidth: 100,
      filterType: "Text",
      editorTemplate: HSN_SAC_EditTemplate,
    },
    {
      name: t("Description"),
      field: "description",
      id: "description",
      width: 120,
      minWidth: 100,
      filterType: "Text",
      editorTemplate: descEditTemplate,
    },
    ...(showRemarksColumn && source == "FormView"
      ? [
          {
            field: "remarks",
            id: "remarks",
            name: t("Remarks"),
            width: 150,
            filterType: "Text",
            formatter: remarksTemplate,
          },
        ]
      : []),
    {
      name: t("Unit"),
      field: "purchaseUnit",
      id: "purchaseUnit",
      _valueGetter: (args: any) => args?.purchaseUnit?.name,
      minWidth: 150,
      formatter: unitTemplate,
      filterType: "Text",
      editorTemplate: unitEditTemplate,
    },
    {
      name: t("Rate"),
      field: "rate",
      id: "rate",
      width: 120,
      minWidth: 100,
      filterType: "Number",
      editorTemplate: rateEditTemplate,
    },
    ...(source == "WBSView"
      ? [
          {
            name: t("Assigned Quantity"),
            field: "availableQuantity",
            id: "availableQuantity",
            minWidth: 100,
            width: 120,
            formatter: assignedQuantityTemplate,
          },
        ]
      : []),
    ...(source == "BoqView"
      ? [
          {
            name: t("WBS Items"),
            field: "wbsItems",
            id: "wbsItems",
            minWidth: 100,
            formatter: wbsItemsTemplate,
            width: 120,
          },
        ]
      : []),
    ...(source == "FormView" || !showDetailedColumns
      ? [
          {
            name: t("Quantity"),
            field: "quantity",
            id: "quantity",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(
                args,
                showManageItemModal.step === manageWBSItemSteps.showParentWBSItems ? "revisedQuantity" : "quantity",
              ),
            editorTemplate: quantityEditTemplate,
          },
          {
            name: t("Amount"),
            field: "revisedAmount",
            id: "revisedAmount",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              amountTemplate(
                args,
                showManageItemModal.step === manageWBSItemSteps.showParentWBSItems ? "revisedAmount" : "amount",
              ),
          },
        ]
      : [
          {
            name: t("Quantity"),
            field: "quantity",
            id: "quantity",
            columnGroup: "Quantity",
            allowEditing: !changeOrderState.isEnabled,
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "quantity"),
            editorTemplate: quantityEditTemplate,
          },
          {
            name: t("Amount"),
            field: "amount",
            id: "amount",
            columnGroup: "Quantity",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) => amountTemplate(args, "amount"),
            editorTemplate: editTemplate,
          },
          {
            name: t("Quantity"),
            field: "changeOrderQuantity",
            id: "changeOrderQuantity",
            width: 120,
            minWidth: 100,
            columnGroup: "Change Order",
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "changeOrderQuantity"),
          },
          {
            name: t("Amount"),
            field: "changeOrderAmount",
            id: "changeOrderAmount",
            width: 120,
            minWidth: 100,
            columnGroup: "Change Order",
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              amountTemplate(args, "changeOrderAmount"),
          },
          {
            name: t("Quantity"),
            field: "revisedQuantity",
            id: "revisedQuantity",
            width: 120,
            minWidth: 100,
            columnGroup: "Revised",
            editorTemplate: quantityEditTemplate,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "revisedQuantity"),
          },
          {
            name: t("Amount"),
            field: "revisedAmount",
            id: "revisedAmount",
            width: 120,
            minWidth: 100,
            columnGroup: "Revised",
            allowEditing: false,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              amountTemplate(args, "revisedAmount"),
          },
          ...(isRustomjeePortal
            ? []
            : [
                {
                  name: t("Quantity"),
                  field: "usedQuantity",
                  id: "usedQuantity",
                  columnGroup: "Used",
                  width: 120,
                  minWidth: 100,
                  formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
                    quantityTemplate(args, "usedQuantity"),
                  allowEditing: false,
                },
                {
                  name: t("Amount"),
                  field: "usedAmount",
                  id: "usedAmount",
                  columnGroup: "Used",
                  width: 120,
                  minWidth: 100,
                  formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
                    amountTemplate(args, "usedAmount"),
                  allowEditing: false,
                },
              ]),
          ...(isRustomjeePortal
            ? []
            : [
                {
                  name: t("Quantity"),
                  field: "remainingQuantity",
                  id: "remainingQuantity",
                  width: 120,
                  minWidth: 100,
                  columnGroup: "Remaining",
                  formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
                    quantityTemplate(args, "remainingQuantity"),
                },
                {
                  name: t("Amount"),
                  columnGroup: "Remaining",
                  field: "remainingAmount",
                  id: "remainingAmount",
                  width: 120,
                  minWidth: 100,
                  formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
                    amountTemplate(args, "remainingAmount"),
                },
              ]),
          {
            name: t("Quantity"),
            columnGroup: `${isRustomjeePortal ? t("Work Done") : t("Inspected")}`,
            field: "inspectedQuantity",
            id: "inspectedQuantity",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "inspectedQuantity"),
          },
          {
            name: t("Amount"),
            columnGroup: `${isRustomjeePortal ? "Work Done" : "Inspected"}`,
            field: "inspectedAmount",
            id: "inspectedAmount",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              amountTemplate(args, "inspectedAmount"),
          },
          {
            name: t("Quantity"),
            field: "billedQuantity",
            columnGroup: "Billed",
            id: "billedQuantity",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "billedQuantity"),
          },
          {
            name: t("Amount"),
            columnGroup: "Billed",
            field: "billedAmount",
            id: "billedAmount",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              amountTemplate(args, "billedAmount"),
          },
        ]),
    ...(showManageItemModal.step === manageWBSItemSteps.showParentWBSItems || source == "FormView"
      ? [
          {
            name: t("Available Quantity"),
            field: "availableQuantity",
            id: "availableQuantity",
            width: 120,
            minWidth: 100,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) =>
              quantityTemplate(args, "availableQuantity"),
          },
        ]
      : []),
    ...(showManageItemModal.step == manageWBSItemSteps.showParentWBSItems || showQuantityInputBox
      ? [
          {
            name: t("Linked Quantity"),
            field: "availableQuantity",
            id: "availableQuantity",
            minWidth: 100,
            width: 120,
            formatter: (data: number, value: number, a: any, b: unknown, args: any) => linkedQuantityTemplate(args),
          },
        ]
      : []),
  ];
  return columnsList;
};
export const noAccessSection = () => (
  <div className="w-full h-full flex gap-4 flex-col items-center justify-center overflow-auto">
    <IconComponent name="NoAccess" width="8rem" height="8rem" />
    <span className="text-xl font-semibold">
      {`You don't have access to this section because you dont have access to respective contract`}
    </span>
  </div>
);
export const mileStonStatusTemplate = (status: any, isSlickGrid = false) => {
  let color = "bg-system_colour_45";
  if (status == mileStoneStatus.yetToStart) {
    color = "bg-system_colour_45";
  } else if (status == mileStoneStatus.inProgress) {
    color = "bg-system_colour_12";
  } else if (status == mileStoneStatus.achieved) {
    color = "bg-positive_communication";
  } else if (status == mileStoneStatus.delayed) {
    color = "bg-system_colour_8";
  } else if (status == mileStoneStatus.beforeTimeCompletion) {
    color = "bg-positive_communication";
  } else if (status == mileStoneStatus.achievedButDelayed) {
    color = "bg-system_colour_8";
  }
  if (isSlickGrid) {
    const container = document.createElement("div");
    const root = createRoot(container);
    root.render(
      <div className={`h-8 ${color} w-fit ps-3 gap-2 bg-opacity-25 rounded-2xl pe-3 flex items-center`}>
        <span className={`${color} rounded-full h-3 w-3`} />
        <span className="font-semibold">{status}</span>
      </div>,
    );
    return container;
  }

  return (
    <div className={`h-8 ${color} w-fit ps-3 gap-2 bg-opacity-25 rounded-2xl pe-3 flex items-center`}>
      <span className={`${color} rounded-full h-3 w-3`} />
      <span className="font-semibold">{status}</span>
    </div>
  );
};
export const DisabledIllustration = () => {
  return (
    <div className="flex justify-center items-center flex-col gap-4 w-full h-full">
      <IconComponent name="disabledModule" width="19.3125rem" height="14.875rem" />
      <span className="font-semibold text-2xl text-text_gray">{t("This Module is Disabled")}</span>
      <span>{t("To Enable it, Please visit to the Detail Section")}</span>
    </div>
  );
};
